import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {setSubmitted, showAddressForm} from '../../actions/ui';
import {addFamilyMember} from '../../actions/familyMembers';
import {getMaritalStatuses} from '../../actions/maritalStatuses';
import MeForm from './forms/MeForm';
import SpouseForm from './forms/SpouseForm';
import FamilyMemberForm from './forms/FamilyMemberForm';
import AddressForm from './forms/AddressForm';
import CongregationForm from './forms/CongregationForm';
import values from 'object-values';
import './index.less';


@connect(
  state => {
    let meErrors = values(state.me)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let spouseErrors = values(state.spouse)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let familyMemberErrors = state.familyMembers.ids
      .map(i => (
        values(state.familyMembers.byId[i])
        .map(i => i.errors)
        .reduce((a, b) => a.concat(b), [])
      ))
      .reduce((a, b) => a.concat(b), []);
    let addressErrors = values(state.address)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let congregationErrors = state.congregations.errors;

    let showSpouseForm = state.me.Marital_Status_ID.value === 2;

    return {
      hasErrors: meErrors.length > 0 || 
        (showSpouseForm && spouseErrors.length > 0) ||
        (familyMemberErrors.length > 0) ||
        (state.ui.showAddressForm && addressErrors.length > 0) ||
        congregationErrors.length > 0,
      showSpouseForm: showSpouseForm,
      showAddressForm: state.ui.showAddressForm,
      familyMembers: state.familyMembers.ids
    };
  },
  dispatch => ({
    setSubmitted(submitted) {
      dispatch(setSubmitted(submitted));
    },
    setShowAddressForm() {
      dispatch(showAddressForm());
    },
    addFamilyMember() {
      dispatch(addFamilyMember());
    },
    getMaritalStatuses() {
      dispatch(getMaritalStatuses());
    }
  })
)
export default class FormRoute extends PureComponent {
  componentDidMount() {
    this.props.getMaritalStatuses();
  }

  render() {
    let {
      showSpouseForm, showAddressForm, setShowAddressForm,
      addFamilyMember, familyMembers
    } = this.props;

    return (
      <div className="route form-route">
        <form onSubmit={this._onSubmit} noValidate>
          <div className="congregation">
            <CongregationForm />
          </div>
          <div className="heads-of-household">
            <MeForm />
            {showSpouseForm && <SpouseForm />}
          </div>
          <div className="family-members">
            {familyMembers.map(i =>
              <FamilyMemberForm key={i} id={i} />
            )}
          </div>
          {showAddressForm && <AddressForm />}
          {!showAddressForm && <div className="add-address-wrapper address-form">
            <button type="button" onClick={() => setShowAddressForm()}>Add Your Address</button>
          </div>}
          <div className="form-controls">
            <button type="button" onClick={() => addFamilyMember()}>Add Child / Family Member (or Guest)</button>
            <button type="submit">Done</button>
          </div>
        </form>
      </div>
    );
  }

  _onSubmit = (event) => {
    event.preventDefault();

    if (this.props.hasErrors) {
      this.props.setSubmitted(true);
    }
    else {
      this.props.history.push('/submit');
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/form-route/index.js